import { Select, useId } from "@fluentui/react-components";
import {
  SelectProps
} from "@fluentui/react-components";
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from "react-redux";

import { useSelector } from "@tdp/core";
import {
  IAnalyticsV2Filters,
  Host,
  analyticsFilterSlice
} from '@tdp/modules/apps';

export const CapabilityFilterDropDown: React.FC = () => {
  const selectId = useId();
  const dispatch = useDispatch();
  const filter: IAnalyticsV2Filters = useSelector((state) => state.analyticsFilter.filters);
  const intl = useIntl();

  const onChange: SelectProps["onChange"] = (_, data) => {
    dispatch(analyticsFilterSlice.actions.updatedAnalyticsFilter(
      {
        ...filter,
        host: data.value as Host
      }
    ));
  };

  return <Select
    style={{ width: "200px" }}
    id={selectId}
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    onChange={onChange} value={filter.host ? filter.host : Host.AllUp}>
    <option value={Host.AllUp}>{intl.formatMessage({ defaultMessage: "All host products", description: "All filter label for the analytics page." })}</option>

    <option value={Host.Teams}>{intl.formatMessage({ defaultMessage: "Teams", description: "Teams filter label for the analytics page." })}</option>
    <option value={Host.Outlook}>
      {intl.formatMessage({ defaultMessage: "Outlook", description: "Outlook filter label for the analytics page." })}
      {` (${intl.formatMessage({ defaultMessage: "Preview", description: "Preview button text in plans and pricing" })})`}
    </option>
    <option value={Host.Harmony}>
      {intl.formatMessage({ defaultMessage: "Microsoft 365 app", description: "Microsoft 365 app filter label for the analytics page." })}
      {` (${intl.formatMessage({ defaultMessage: "Preview", description: "Preview button text in plans and pricing" })}) `}
    </option>
    <option value={Host.Copilot}>
      {intl.formatMessage({ defaultMessage: "Copilot", description: "Copilot filter label for the analytics page." })}
      {` (${intl.formatMessage({ defaultMessage: "new", description: "New tag for copilot filter option" })}) `}
    </option>
  </Select>
};
